import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `vehicle`);
        return response;
    } catch (e) { }
}

export async function getVehicle(id?: string) {
    try {
        const response = await apiGet('core', `vehicle/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addVehicle(newDetails: any) {
    try {
        const response = await apiPost('core', `vehicle`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateVehicle(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `vehicle/${id}`, newDetails);

        return response.content;
    } catch (e) { }
}

export async function removeVehicle(id: any) {
    try {

        return await apiDelete('core', `vehicle/${id}`);
    } catch (e) { }
}

export async function duplicateVehicle(id?: string) {
    try {
        const response = await apiGet('core', `vehicle-duplicate/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}